<template>
  <header class="bg-white">
    <nav
      class="mx-auto flex max-w-7xl items-center justify-between p-6 lg:px-8"
      aria-label="Global"
    >
      <div class="flex lg:flex-1">
        <a
          class="flex items-center mt-2 lg:mt-0 mr-1"
          href="/"
        >
          <img
            class="p-1 rounded max-w-sm mr-4"
            src="https://d74h3bbw65d2l.cloudfront.net/sabine-pretsch-logo.svg"
            style="height: 56px;"
            alt="Sabine Pretsch, Logo"
          >
          <div>
            <h1 class="text-2xl font-sans font-bold text-teal-600">
              Sabine Pretsch
            </h1>
            
          </div></a>
      </div>

      <div class="flex lg:hidden">
        <button
          type="button"
          class="-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-gray-700"
          @click="mobileMenuOpen = true"
        >
          <span class="sr-only">Hauptmenü öffnen</span>
          <Bars3Icon
            class="h-6 w-6"
            aria-hidden="true"
          />
        </button>
      </div>

      <PopoverGroup class="hidden lg:flex lg:gap-x-12">
        <a
          href="/ueber-mich"
          class="transition font-semibold leading-6 hover:text-teal-500 dark:hover:text-teal-400"
        >Über mich</a>
        <a
          href="/beratung"
          class="transition font-semibold leading-6 hover:text-teal-500 dark:hover:text-teal-400"
        >Beratung</a>
        <a
          href="/coaching"
          class="transition font-semibold leading-6 hover:text-teal-500 dark:hover:text-teal-400"
        >Coaching</a>

        <Popover class="relative">
          <PopoverButton
            class="flex items-center gap-x-1 font-semibold leading-6 hover:text-teal-500 dark:hover:text-teal-400"
          >
            Entspannung
            <ChevronDownIcon
              class="h-5 w-5 flex-none text-gray-400"
              aria-hidden="true"
            />
          </PopoverButton>

          <transition
            enter-active-class="transition ease-out duration-200"
            enter-from-class="opacity-0 translate-y-1"
            enter-to-class="opacity-100 translate-y-0"
            leave-active-class="transition ease-in duration-150"
            leave-from-class="opacity-100 translate-y-0"
            leave-to-class="opacity-0 translate-y-1"
          >
            <PopoverPanel
              class="absolute -left-8 top-full z-10 mt-3 w-screen max-w-md overflow-hidden rounded-3xl bg-white shadow-lg ring-1 ring-gray-900/5"
            >
              <div class="p-4">
                <div
                  v-for="item in relax"
                  :key="item.title"
                  class="group relative flex items-center gap-x-6 rounded-lg p-4 text-sm leading-6 hover:bg-teal-50"
                >
                  <div
                    class="flex h-11 w-11 flex-none items-center justify-center rounded-lg bg-teal-50 group-hover:bg-white"
                  >
                    <component
                      :is="item.icon"
                      class="h-6 w-6 text-gray-600 group-hover:text-teal-600"
                      aria-hidden="true" />
                  </div>
                  <div class="flex-auto">
                    <a
                      :href="item.href"
                      class="block font-semibold text-gray-900"
                    >
                      {{ item.title }}
                      <span class="absolute inset-0" />
                    </a>
                    <p class="mt-1 text-gray-600">
                      {{ item.description }}
                    </p>
                  </div>
                </div>
              </div>

            </PopoverPanel>
          </transition>
        </Popover>
      </PopoverGroup>
      
      <div class="hidden lg:flex lg:flex-1 lg:justify-end">
        <a
          href="/kontakt"
          class="font-semibold leading-6 hover:text-teal-500 dark:hover:text-teal-400 mr-4"
        >Kontakt</a>
      
        <a
          href="https://www.instagram.com/sabine_pretsch"
          class="font-semibold leading-6 hover:text-teal-500 dark:hover:text-teal-400 mr-4"
        > <img
          class="h-5 w-auto"
          src="https://d74h3bbw65d2l.cloudfront.net/instagram.svg"
          alt=""
        >
        </a>
      
        <a
          href="https://www.xing.com/profile/Sabine_Pretsch"
          class="font-semibold leading-6 hover:text-teal-500 dark:hover:text-teal-400"
        ><img
          class="h-5 w-auto"
          src="https://d74h3bbw65d2l.cloudfront.net/xing.svg"
          alt=""
        ></a>
      </div>
    </nav>
   
    <Dialog class="lg:hidden" @close="mobileMenuOpen = false" :open="mobileMenuOpen">
      <div class="fixed inset-0 z-10" />
      <DialogPanel
        class="fixed inset-y-0 right-0 z-10 w-full overflow-y-auto bg-white px-6 py-6 sm:max-w-sm sm:ring-1 sm:ring-gray-900/10"
      >
        <div class="flex items-center justify-between">
          <a
            href="#"
            class="-m-1.5 p-1.5"
          >
            <span class="sr-only">Sabine Pretsch</span>
            <img
              class="h-8 w-auto"
              src="https://d74h3bbw65d2l.cloudfront.net/sabine-pretsch-logo.svg"
              alt=""
            >
          </a>
          <button
            type="button"
            class="-m-2.5 rounded-md p-2.5 text-gray-700"
            @click="mobileMenuOpen = false"
          >
            <span class="sr-only">Menü schließen</span>
            <XMarkIcon class="size-6" aria-hidden="true" />
          </button>
        </div>
        
        <div class="mt-6 flow-root">
          <div class="-my-6 divide-y divide-gray-500/10">
            <div class="space-y-2 pt-6">
            
              <a
                href="/ueber-mich"
                class="-mx-3 block rounded-lg px-3 py-2 text-base font-semibold leading-7 text-gray-900 hover:bg-teal-50"
              >Über mich</a>
           
              <a
                href="/beratung"
                class="-mx-3 block rounded-lg px-3 py-2 text-base font-semibold leading-7 text-gray-900 hover:bg-teal-50"
              >Beratung</a>
              <a
                href="/coaching"
                class="-mx-3 block rounded-lg px-3 py-2 text-base font-semibold leading-7 text-gray-900 hover:bg-teal-50"
              >Coaching</a>
              
              
              <Disclosure as="div" class="-mx-3" v-slot="{ open }">
                <DisclosureButton class="flex w-full items-center justify-between rounded-lg py-2 pl-3 pr-3.5 text-base/7 font-semibold text-gray-900 hover:bg-teal-50">
                  Entspannung
                  <ChevronDownIcon :class="[open ? 'rotate-180' : '', 'size-5 flex-none']" aria-hidden="true" />
                </DisclosureButton>
                <DisclosurePanel class="mt-2 space-y-2">
                  <DisclosureButton v-for="item in relax" :key="item.title" as="a" :href="item.href" class="block rounded-lg py-2 pl-6 pr-3 text-sm/7 font-semibold text-gray-900 hover:bg-teal-50">{{ item.title }}</DisclosureButton>
                </DisclosurePanel>
              </Disclosure>
              
            </div>
            <div>
              <a
                href="/kontakt"
                class="-mx-3 block rounded-lg px-3 py-2.5 text-base font-semibold leading-7 text-gray-900 hover:bg-teal-50"
              >Kontakt</a>
            </div>
          
            <div>
            <a
              href="https://www.instagram.com/sabine_pretsch"
              class="-mx-3 block rounded-lg px-3 py-2.5 text-base font-semibold leading-7 text-gray-900 hover:bg-teal-50"> 
              <img
              class="h-5 w-auto"
              src="https://d74h3bbw65d2l.cloudfront.net/instagram.svg"
              alt="Mein Instagram">
            </a>
            </div>
            
            <div>
            <a
              href="https://www.xing.com/profile/Sabine_Pretsch"
              class="-mx-3 block rounded-lg px-3 py-2.5 text-base font-semibold leading-7 text-gray-900 hover:bg-teal-50"> 
              <img
              class="h-5 w-auto"
              src="https://d74h3bbw65d2l.cloudfront.net/xing.svg"
              alt="Mein Xing"> 
            </a>
            </div>
            
          </div>
        </div>
      </DialogPanel>
    </Dialog>
  </header>
</template>

<script setup>
import { ref, onMounted } from "vue";
import {
  Dialog,
  DialogPanel,
  Disclosure,
  DisclosureButton,
  DisclosurePanel,
  Popover,
  PopoverButton,
  PopoverGroup,
  PopoverPanel,
} from "@headlessui/vue";
import {
  ArrowPathIcon,
  Bars3Icon,
  ChartPieIcon,
  CursorArrowRaysIcon,
  FingerPrintIcon,
  SquaresPlusIcon,
  XMarkIcon,
  MusicalNoteIcon,
  MicrophoneIcon,
  ArrowRightCircleIcon,
  CheckBadgeIcon,
  HeartIcon,
  RadioIcon,
  SignalIcon,
  SparklesIcon,
} from "@heroicons/vue/24/outline";
import {
  ChevronDownIcon,
  PhoneIcon,
  PlayCircleIcon,
} from "@heroicons/vue/20/solid";
import axios from "axios";

const relax = [
  {
    sortierfeld: 2,
    title: "Klang",
    description: "Entspannung mit Klangerlebnissen",
    href: "/entspannung/klang",
    icon: MusicalNoteIcon,
  },
  {
    sortierfeld: 1,
    title: "Kochen",
    description: "Nepalesisch ayurvedisch kochen",
    href: "/entspannung/kochen",
    icon: ChartPieIcon,
  },
  {
    sortierfeld: 3,
    title: "Auszeit",
    description: "Reisen und mein Podcast",
    href: "/entspannung/auszeit",
    icon: MicrophoneIcon,
  },
  {
    title: "Mountain View House",
    description: "Rückzugsort im Himalaya",
    href: "/entspannung/tibet",
    icon: SparklesIcon,
  },
  {
    title: "weitere Methoden",
    description: "Lebensqualität durch Entspannung",
    href: "/entspannung/weitere-methoden",
    icon: HeartIcon,
  },
];

const mobileMenuOpen = ref(false);

// Beispiel für das Laden externer Daten
const entspannungen = ref([]);
onMounted(async () => {
  const response = await axios.get("/entspannungen.json");
  entspannungen.value = response.data;
});
</script>
